/** No matching MUI theme token exists for this green yet. */
export const VERIFY_ASSETS_SUCCESS_COLOR = '#21a977';

/** Cart check once the case is confirmed — Figma "Case Details / complete" (#1D2A40 @ 70%). */
export const VERIFY_ASSETS_CONFIRMED_CART_COLOR = 'rgba(29, 42, 64, 0.7)';
